module.exports = __webpack_public_path__ + "static/media/special-offer-left.14d9def3.png";